import { Mail } from "lucide-react";
import { Reveal } from "./Reveal";
import { ContactForm } from "./ContactForm";
import { InstagramIcon, TikTokIcon, WhatsAppIcon } from "./BrandIcons";
import { SITE, waLink } from "@/lib/site";

const CHANNELS = [
  { id: "whatsapp", icon: WhatsAppIcon, label: "WhatsApp", value: SITE.whatsappDisplay, href: waLink() },
  { id: "email", icon: Mail, label: "E-mail", value: SITE.email, href: `mailto:${SITE.email}` },
  { id: "instagram", icon: InstagramIcon, label: "Instagram", value: `@${SITE.instagramHandle}`, href: SITE.instagram },
  { id: "tiktok", icon: TikTokIcon, label: "TikTok", value: `@${SITE.tiktokHandle}`, href: SITE.tiktok },
];

export const Contact = () => (
  <section id="contato" data-testid="contact-section" className="relative py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-5">
        <Reveal>
          <p className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.28em] text-ws-lime">
            <span className="text-ws-muted">[09]</span><span className="h-px w-8 bg-ws-lime/60" />Contato
          </p>
          <h2 data-testid="contact-title" className="mt-6 font-display text-3xl font-semibold leading-[1.12] tracking-tight sm:text-4xl lg:text-5xl">
            Vamos criar o seu projeto?
          </h2>
          <p className="mt-6 text-base leading-relaxed text-ws-muted md:text-lg">
            Preencha o formulário e fale com um especialista da WebStation. O orçamento é personalizado e apresentado diretamente no atendimento.
          </p>
        </Reveal>
        <div className="mt-10 space-y-3">
          {CHANNELS.map((c, i) => (
            <Reveal key={c.id} delay={0.1 + i * 0.06}>
              <a data-testid={`contact-channel-${c.id}`} href={c.href} target={c.id === "email" ? undefined : "_blank"} rel="noopener noreferrer" className="group flex items-center gap-4 rounded-2xl border border-white/[0.07] bg-ws-card p-4 transition-[border-color,background-color] duration-300 hover:border-ws-lime/40 hover:bg-ws-raised">
                <span className="grid h-11 w-11 place-items-center rounded-xl bg-ws-lime/10 text-ws-lime transition-transform duration-300 group-hover:scale-110"><c.icon size={20} /></span>
                <span>
                  <span className="block font-mono text-[11px] uppercase tracking-widest text-ws-muted">{c.label}</span>
                  <span className="block text-[15px] font-medium text-ws-text">{c.value}</span>
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
      <Reveal delay={0.1} className="lg:col-span-7">
        <div className="relative rounded-[2rem] border border-white/[0.08] bg-ws-card p-6 shadow-[0_40px_100px_-40px_rgba(124,255,26,.25)] sm:p-10">
          <div className="pointer-events-none absolute -top-px left-10 right-10 h-px bg-gradient-to-r from-transparent via-ws-lime to-transparent" />
          <ContactForm />
        </div>
      </Reveal>
    </div>
  </section>
);
